export const ProfileEnum = {
    MyProfile: 0,
    Identification:1,
    Documents: 2,
    Preferences: 3,
    Security: 4,
    ResponsibleGaming: 5,
    ActivityLog: 6,
    Passkey: 8,
}

Object.freeze(ProfileEnum);

export default ProfileEnum;